export default "__VITE_ASSET__5a19f988__"